module.exports = __webpack_public_path__ + "img/mkhdx.6accb695.png";